import { DtButton } from '@ow/ditto-core'

const { transformer } = DtButton

export { transformer }
